import axiosWrapper from '../helpers/api'
import { ERequestUrl, EMethods } from '../helpers/requests'

export const getPromotions = () =>
  axiosWrapper({
    method: EMethods.get,
    url: ERequestUrl.promotions,
  })
